export default __webpack_public_path__ + "static/media/copy.68d01396.svg";